import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import config from "../../config/config";

class Insights {
	private appInsights: ApplicationInsights;

	constructor() {
		const key = config.applicationInsightsKey;
		this.appInsights = new ApplicationInsights({
			config: {
				connectionString: key,
				enableAutoRouteTracking: false,
				samplingPercentage: 100,
			},
		});
		this.appInsights.loadAppInsights();
	}

	public setUser(subject: string, system: string | undefined) {
		this.appInsights.setAuthenticatedUserContext(subject, system);
	}

	public trackPageView(isSupport: boolean, isDeveloper: boolean, name?: string, uri?: string) {
		this.appInsights.trackPageView({
			name: name || document.title,
			uri: uri || window.location.href,
			properties: {
				isSupport: isSupport,
				isDeveloper: isDeveloper,
				"device.viewPort": `${window.outerWidth}*${window.outerHeight}`,
			},
		});
	}

	public trackEvent(eventName: string, properties?: { [key: string]: string | object }) {
		this.appInsights.trackEvent({ name: eventName }, properties);
	}

	public trackException(error: Error, severityLevel?: number) {
		this.appInsights.trackException({
			exception: error,
			severityLevel: severityLevel,
		});
	}

	public trackMetric(name: string, average: number, properties?: { [key: string]: string | object }) {
		this.appInsights.trackMetric({ name, average }, properties);
	}
}

export default new Insights();
